var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-main', [_c('v-app-bar', {
    attrs: {
      "app": ""
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var hover = _ref.hover;
        return _c('v-toolbar-title', {
          staticClass: "ws-detail-title"
        }, [!hover && !_vm.editing ? _c('v-icon', {
          staticClass: "ml-4 mr-5",
          attrs: {
            "color": "grey lighten-1"
          }
        }, [_vm._v(" mdi-text-box-multiple ")]) : _vm._e(), !_vm.editing && hover ? _c('v-tooltip', {
          attrs: {
            "left": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref2) {
              var on = _ref2.on;
              return [_c('div', [_c('v-btn', _vm._g({
                staticClass: "ml-1 mr-2",
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function click($event) {
                    _vm.editing = !_vm.editing;
                  }
                }
              }, on), [_c('v-icon', {
                attrs: {
                  "color": "grey darken-3",
                  "size": "20px"
                }
              }, [_vm._v(" mdi-pencil ")])], 1)], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v("Rename workspace")])]) : _vm._e(), _vm.editing ? _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function click($event) {
              _vm.editing = !_vm.editing;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "grey darken-3",
            "size": "20px"
          },
          on: {
            "click": _vm.cancelRename
          }
        }, [_vm._v(" mdi-close ")])], 1) : _vm._e(), _vm.editing ? _c('v-text-field', {
          staticClass: "ws-rename",
          attrs: {
            "autofocus": "",
            "background-color": "transparent",
            "text": "",
            "solo": "",
            "flat": "",
            "dense": "",
            "error-messages": _vm.nameErrorMessages
          },
          on: {
            "focus": function focus($event) {
              return $event.target.select();
            },
            "keydown": [function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.renameWorkspace.apply(null, arguments);
            }, function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
              return _vm.cancelRename.apply(null, arguments);
            }]
          },
          model: {
            value: _vm.localWorkspace,
            callback: function callback($$v) {
              _vm.localWorkspace = $$v;
            },
            expression: "localWorkspace"
          }
        }) : _c('span', [_vm._v(_vm._s(_vm.workspace))])], 1);
      }
    }])
  }), _vm.loading ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "absolute": "",
      "bottom": ""
    }
  }) : _vm._e(), _c('v-spacer'), _c('workspace-option-menu', {
    attrs: {
      "workspace": _vm.workspace
    }
  })], 1), _vm._l(_vm.uploads, function (upload) {
    return _c('v-row', {
      key: upload.id
    }, [_c('v-col', {
      staticClass: "ma-0",
      attrs: {
        "cols": "12"
      }
    }, [upload.status === 'FAILED' ? _c('v-alert', {
      staticClass: "mb-0",
      attrs: {
        "border": "left",
        "color": "red",
        "type": "error"
      }
    }, [_vm._v(" Failed to upload " + _vm._s(upload.blob.substring(upload.blob.indexOf('/') + 1)) + " at " + _vm._s(new Date(upload.created).toLocaleString()) + " because: " + _vm._s(upload.error_messages.join('. ')) + " ")]) : _c('v-alert', {
      staticClass: "mb-0",
      attrs: {
        "border": "left",
        "color": "blue",
        "type": "info"
      }
    }, [_c('v-row', {
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      staticClass: "grow"
    }, [_vm._v(" Uploading: " + _vm._s(upload.blob.substring(upload.blob.indexOf('/') + 1)) + " ")]), _c('v-col', {
      staticClass: "shrink"
    }, [_c('v-progress-circular', {
      attrs: {
        "indeterminate": "",
        "color": "white",
        "size": "26"
      }
    })], 1)], 1)], 1)], 1)], 1);
  }), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "px-5",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "transparent",
      "flat": "",
      "text": ""
    }
  }, [_c('network-panel', {
    attrs: {
      "workspace": _vm.workspace,
      "items": _vm.networks,
      "node-tables": _vm.nodeTables.map(function (table) {
        return table.name;
      }),
      "edge-tables": _vm.edgeTables.map(function (table) {
        return table.name;
      }),
      "loading": _vm.loading,
      "apps": _vm.apps
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "px-5",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "transparent",
      "flat": "",
      "text": ""
    }
  }, [_c('table-panel', {
    attrs: {
      "workspace": _vm.workspace,
      "items": _vm.tables,
      "loading": _vm.loading,
      "apps": _vm.apps
    }
  })], 1)], 1)], 1)], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }